import React, { useState } from 'react';
import ServicesHeroModal from './editor_modals/services_modals/ServicesHeroModal';
import FeaturedServicesModal from './editor_modals/services_modals/FeaturedServicesModal';
import ServiceCardsModal from './editor_modals/services_modals/ServiceCardsModal';
import ServicesCTAModal from './editor_modals/services_modals/ServicesCTAModal';
import Services from '../../pages/Services';



const ServicesEditor = () => {
  const [isHeroOpen, setHeroOpen] = useState(false);
  const [isFeaturedServicesOpen, setFeaturedServicesOpen] = useState(false);
  const [isServiceCardsOpen, setServiceCardsOpen] = useState(false);
  const [isServicesCTAOpen, setServicesCTAOpen] = useState(false);

  return (
    <div className='grid grid-cols-5 gap-20 items-start justify-between p-20 w-[1300px]'>
      {/* Buttons Section */}
      <div className='grid grid-cols-1 gap-28 font-bold text-center my-auto'>
        <button className="btn btn-primary w-20 m-2 p-2" onClick={() => setHeroOpen(true)}>Services Hero</button>
        <button className="btn btn-primary w-20 m-2" onClick={() => setFeaturedServicesOpen(true)}>Featured Services</button>
        <button className="btn btn-primary w-20 m-2" onClick={() => setServiceCardsOpen(true)}>Service Cards</button>
        <button className="btn btn-primary w-20 m-2 px-12" onClick={() => setServicesCTAOpen(true)}>Services CTA</button>
      </div>

      {/* Mockup Browser Section */}
      <div className="col-span-4 mockup-browser bg-white border-8 border-black p-2 h-[1000px] overflow-y-scroll">
        <div>
          <div className="mockup-browser-toolbar m-10">
            <div className="input">https://sample-website.com</div>
          </div>
          <div className='overflow-scroll'>
            <Services />
          </div>
        </div>
      </div>

      {/* Modal Components */}
      <ServicesHeroModal isOpen={isHeroOpen} onClose={() => setHeroOpen(false)} />
      <FeaturedServicesModal isOpen={isFeaturedServicesOpen} onClose={() => setFeaturedServicesOpen(false)} />
      <ServiceCardsModal isOpen={isServiceCardsOpen} onClose={() => setServiceCardsOpen(false)} />
      <ServicesCTAModal isOpen={isServicesCTAOpen} onClose={() => setServicesCTAOpen(false)} />
    </div>
  );
};

export default ServicesEditor;
